import brandLogo from '../assets/images/brand-logo.svg';
import './Header.css';
import { useLocation, useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSmoothScroll = (event, targetElementId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetElementId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleBrandClick = (event) => {
    if (location.pathname !== '/') {
      event.preventDefault();
      navigate('/');
      return;
    }
    handleSmoothScroll(event, 'top');
  };

  return (
    <header className="SiteHeader">
      <div className="Header-inner">
        <a
          href="/"
          className="Brand"
          onClick={handleBrandClick}
        >
          <img src={brandLogo} className="Brand-logo" alt="YStudioX logo" />
          <span className="Brand-name">YStudioX</span>
        </a>
        <nav className="Nav">
          <a
            href="#apps"
            className="Nav-link"
            onClick={(event) => handleSmoothScroll(event, 'apps')}
          >アプリ</a>
          <a
            href="#about"
            className="Nav-link"
            onClick={(event) => handleSmoothScroll(event, 'about')}
          >開発者について</a>
          <a
            href="#contact"
            className="Nav-link"
            onClick={(event) => handleSmoothScroll(event, 'contact')}
          >お問い合わせ</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
